// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnnouncementListSkeleton_wrapper__vZopI","list-item":"AnnouncementListSkeleton_list-item__6Z65Q"};